import { render } from "./AttachmentsGallery.vue?vue&type=template&id=29f4ac0a&scoped=true"
import script from "./AttachmentsGallery.vue?vue&type=script&lang=js"
export * from "./AttachmentsGallery.vue?vue&type=script&lang=js"

import "./AttachmentsGallery.vue?vue&type=style&index=0&id=29f4ac0a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f4ac0a"]])

export default __exports__